<section class="landing-login parking-lotpage">  
  <app-header-v1 [presentComponent]="presentComponent"></app-header-v1>  
  <div class="parkinglot-bannersec driverv1-banner">
    <div class="bg-img">
      <img
        src="../../assets/images/landing-page/parking-banner-bg.png"
        alt="Banner Background"
        class="img-fluid"
      />
    </div>
    <div class="landing-container">
      <div class="driver-v1">
        <h1 class="banner-heading">Your home away from home</h1>
        <p>
          A Hassle-Free and Lightning-Fast Parking Experience for Truck Drivers
        </p>
      </div>

      <div class="banner-btnbox">
        <a class="banner-btn" routerLink="/login"> Book Now </a>
      </div>
      <div class="banner-img parking-img desktop-outer">
        <img
          src="../../assets/images/desktopScanner.png"
          alt="Banner"
          class="img-fluid"
        />
      </div>
      <div class="banner-img parking-img mobile-outer">
        <img
          src="../../assets/images/driver-img-mobile.png"
          alt="Banner"
          class="img-fluid"
        />
        <p class="description">Get App On Your Device</p>
        <div class="mobile-view">
          <div class="app-btn">
            <a href="https://apps.apple.com/us/app/trucklots/id6472444340" target="_blank" rel="noopener"
              ><img src="assets/images/app-store.png" alt="App Store"
            /></a>
          </div>
          <div class="google-btn">
            <a
              href="https://play.google.com/store/apps/details?id=com.trucklots.parkingdriver" target="_blank" rel="noopener"
              ><img src="assets/images/google-play.png"  alt="Google Play"
            /></a>
          </div>
        </div>
      </div>

<app-feature-box [features]="features"></app-feature-box>
    </div>
  </div>

<div class="community-sec"  id="community-sec">
    <div class="map-box">
      <app-join-our-community-map></app-join-our-community-map>
    </div>
  </div>
</section>
<app-footer></app-footer>
